import React from 'react';

class DragAndDropBox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      drag: false
    }
  }

  dropRef = React.createRef()

  handleDrag = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  handleDragIn = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.dragCounter++
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true })
    }
  }

  handleDragOut = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.dragCounter--
    if (this.dragCounter === 0) {
      this.setState({ drag: false })
    }
  }

  handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ drag: false })
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.props.handleDrop(e.dataTransfer.files)
      e.dataTransfer.clearData()
      this.dragCounter = 0
    }
  }

  componentDidMount() {
    let div = this.dropRef.current
    div.addEventListener('dragenter', this.handleDragIn)
    div.addEventListener('dragleave', this.handleDragOut)
    div.addEventListener('dragover', this.handleDrag)
    div.addEventListener('drop', this.handleDrop)
  }

  componentWillUnmount() {
    let div = this.dropRef.current
    div.removeEventListener('dragenter', this.handleDragIn)
    div.removeEventListener('dragleave', this.handleDragOut)
    div.removeEventListener('dragover', this.handleDrag)
    div.removeEventListener('drop', this.handleDrop)
  }

  render() {
    const { id } = this.props;
    const fileListLength = this.props.files.length;

    return (
      <div className='form-group row'>
        <div className={`box-input ${this.state.drag ? 'dragging-file' : ''}`} ref={this.dropRef} id={id}>
          <div className='icon-file-upload' />
          {
            this.state.drag ?
              <span className='blue'>Drop here</span> :
              <span className='blue'>Drag and drop your files here</span>
          }
          <div className={`${fileListLength > 0 ? 'filename-zone' : 'd-none'}`}>
            <strong>
              {
                this.props.files.map((file, i) => <div key={file.split('.')[0]}><span>{file}</span></div>)
              }
            </strong>
          </div>
          <div className={`${fileListLength === 0 ? 'd-none' : ''}`}>
            <span className='blue'>{`${fileListLength === 1 ? 'is' : 'are'} now uploaded`}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default DragAndDropBox;